import { defineMessages } from 'react-intl';
export const messages: {
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'comment-result.label',
		defaultMessage: 'Comment',
		description:
			'Badge label shown on a comment search result card to identify the result type as a comment.',
	},
});
